import { isKnownBreachedPassword } from './breachedPasswords.js';

export interface PasswordPolicyResult {
  valid: boolean;
  errors: string[];
}

const MIN_LENGTH = 10;

export function checkPasswordPolicy(password: string): PasswordPolicyResult {
  const errors: string[] = [];
  if (password.length < MIN_LENGTH) {
    errors.push(`Password must be at least ${String(MIN_LENGTH)} characters.`);
  }
  if (isKnownBreachedPassword(password)) {
    errors.push('This password has appeared in known data breaches. Please choose another.');
  }
  return { valid: errors.length === 0, errors };
}
